import SupportAdminView from "../../components/support/SupportAdminView";

export function SupportPage() {
  return <SupportAdminView />;
}

export default SupportPage;
